import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface DeleteUserResponse {
  data: null
  meta: {
    message: string
    errors: string[]
  }
}

export function deleteUserAction(userId: string): Promise<ApiResponse<DeleteUserResponse>> {
  return api.delete<ApiResponse<DeleteUserResponse>>(`/users/${userId}`)
}
